// Persistent anonymous device ID for retention analytics.
// One UUID per browser/PWA install, stored in localStorage. Never sent to
// third parties — only to our own /api endpoints to link sessions from
// the same device across days.
const KEY = "stillroom.deviceId.v1";

function makeUuid() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  // Fallback for older browsers.
  return "d_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2, 12);
}

export function getDeviceId() {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id = makeUuid();
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    // Storage disabled (private mode, etc.) — return a per-load ID so the
    // request still works even if we can't persist.
    return makeUuid();
  }
}
